import React, { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { InputBase } from '@mui/material';

import { classNames } from '../utils';

import styles from './SearchBar.module.css';

interface SearchBarProps {
  searchTerm: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  expanded?: boolean;
  iconPos?: 'right' | 'left';
  iconCol?: string;
  classes?: string[];
  stable?: boolean;
}

export default function SearchBar({
  onChange,
  searchTerm,
  placeholder = 'Search',
  expanded = false, // expansion enabled or disabled
  iconPos = 'right',
  iconCol = '#fff',
  classes = [],
  stable = false,
}: SearchBarProps) {
  const [expandSearch, setExpandSearch] = useState<boolean>(expanded);

  const handleBlur = () => {
    if (stable) return;
    if (!expanded) setExpandSearch(Boolean(searchTerm));
  };

  return (
    <div
      className={classNames(
        iconPos === 'right' ? styles.search_right : styles.search_left,
        stable && styles.search_stable,
        ...classes,
      )}
      id={
        !stable
          ? expandSearch
            ? styles.search_expanded
            : styles.search_hidden
          : undefined
      }
      style={expanded || stable ? { marginLeft: 0 } : undefined}
    >
      <InputBase
        value={searchTerm}
        onChange={onChange}
        onFocus={() => setExpandSearch(true)}
        onBlur={handleBlur}
        className={styles.search_input}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search' }}
      />
      <div className={styles.search_icon_wrapper}>
        <SearchIcon sx={{ color: iconCol }} />
      </div>
    </div>
  );
}
